

const FooterSettings = ()=> {
    return(
        <div>Footer</div>
    )
}
export default FooterSettings;